export const getDocument = () => {
  var _window;
  return (_window = window) === null || _window === void 0 ? void 0 : _window.document;
};